<template>
  <v-container width="100%" style="background: #f5f5f5">
    <v-dialog v-model="editDialog" max-width="900px">
      <ManageSupplier
        :title="$t('Editar fornecedor')"
        :supplier="currentSupplier"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <div id="header" class="mt-5 px-3">
      <h2>{{ $t('Dados fornecedor') }}</h2>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="userType != 3"
            class="ma-1"
            color="#0F3565"
            dark
            @click="editSupplier(currentSupplier)"
            v-bind="attrs"
            v-on="on"
            small
          >
            <v-icon dark small> mdi-pencil-outline </v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
    </div>
    <v-divider class="my-3"></v-divider>

    <v-row class="px-5 hidden-sm-and-down">
      <v-col cols="6">
        <h3>{{ $t('Informações institucionais') }}</h3>
      </v-col>
      <v-col cols="6">
        <h3>{{ $t('Endereço') }}</h3>
      </v-col>
      <v-col cols="6">
        <p>
          <strong class="field">{{ $t('Fornecedor') }}:</strong>
          {{ currentSupplier.name }}
        </p>
        <p>
          <strong class="field">{{ $t('Razão social') }}:</strong>
          {{ currentSupplier.corporateName }}
        </p>
        <p>
          <strong class="field">CNPJ:</strong>
          {{ currentSupplier.cnpj }}
        </p>
        <p>
          <strong class="field">Website:</strong>
          {{
            currentSupplier.webSite != ''
              ? currentSupplier.webSite
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="2">
        <p>
          <strong class="field">CEP:</strong>
          {{
            currentSupplier.cep != ''
              ? currentSupplier.cep
              : $t('Não informado')
          }}
        </p>

        <p>
          <strong class="field">Número:</strong>
          {{
            currentSupplier.locationNumber != null
              ? currentSupplier.locationNumber
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">{{ $t('Bairro') }}:</strong>
          {{
            currentSupplier.district != ''
              ? currentSupplier.district
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">UF:</strong>
          {{ currentSupplier.state }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <strong class="field">{{ $t('Logradouro') }}:</strong>
          {{
            currentSupplier.address != ''
              ? currentSupplier.address
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">{{ $t('Complemento') }}:</strong>
          {{
            currentSupplier.complement != ''
              ? currentSupplier.complement
              : $t('Não informado')
          }}
        </p>

        <p>
          <strong class="field">{{ $t('Cidade') }}:</strong>
          {{ currentSupplier.city }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3 hidden-sm-and-down"></v-divider>
    <v-row class="px-5 hidden-sm-and-down">
      <v-col cols="12" sm="6" md="6" lg="6">
        <h3>{{ $t('Contato técnico') }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <h3>{{ $t('Contato comercial') }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Nome') }}:</strong>
          {{
            currentSupplier.technicalContact != ''
              ? currentSupplier.technicalContact
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">E-mail:</strong>
          {{
            currentSupplier.technicalEmail != ''
              ? currentSupplier.technicalEmail
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">{{ $t('Telefone') }}:</strong>
          {{
            currentSupplier.technicalPhoneNumber != ''
              ? currentSupplier.technicalPhoneNumber
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">{{ $t('Celular') }}:</strong>
          {{
            currentSupplier.technicalCellPhoneNumber != ''
              ? currentSupplier.technicalCellPhoneNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Nome') }}:</strong>
          {{
            currentSupplier.businessContact != ''
              ? currentSupplier.businessContact
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">E-mail:</strong>
          {{
            currentSupplier.businessEmail != ''
              ? currentSupplier.businessEmail
              : $t('Não informado')
          }}
        </p>
        <p>
          <strong class="field">{{ $t('Telefone') }}:</strong>
          {{
            currentSupplier.businessPhoneNumber != ''
              ? currentSupplier.businessPhoneNumber
              : c
          }}
        </p>
        <p>
          <strong class="field">{{ $t('Celular') }}:</strong>
          {{
            currentSupplier.businessCellPhoneNumber != ''
              ? currentSupplier.businessCellPhoneNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
    </v-row>
    <v-row class="px-5 hidden-md-and-up">
      <v-col cols="12">
        <h3>{{ $t('Informações institucionais') }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Fornecedor') }}:</strong>
          {{ currentSupplier.name }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Razão social') }}:</strong>
          {{ currentSupplier.corporateName }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">CNPJ:</strong>
          {{ currentSupplier.cnpj }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">Website:</strong>
          {{
            currentSupplier.webSite != ''
              ? currentSupplier.webSite
              : $t('Não informado')
          }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3 hidden-md-and-up"></v-divider>
    <v-row class="px-5 hidden-md-and-up">
      <v-col cols="12">
        <h3>{{ $t('Contato técnico') }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Nome') }}:</strong>
          {{
            currentSupplier.technicalContact != ''
              ? currentSupplier.technicalContact
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">E-mail:</strong>
          {{
            currentSupplier.technicalEmail != ''
              ? currentSupplier.technicalEmail
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Telefone') }}:</strong>
          {{
            currentSupplier.technicalPhoneNumber != ''
              ? currentSupplier.technicalPhoneNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Celular') }}:</strong>
          {{
            currentSupplier.technicalCellPhoneNumber != ''
              ? currentSupplier.technicalCellPhoneNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3 hidden-md-and-up"></v-divider>
    <v-row class="px-5 hidden-md-and-up">
      <v-col cols="12">
        <h3>{{ $t('Contato comercial') }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">Nome:</strong>
          {{
            currentSupplier.businessContact != ''
              ? currentSupplier.businessContact
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">E-mail:</strong>
          {{
            currentSupplier.businessEmail != ''
              ? currentSupplier.businessEmail
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Telefone') }}:</strong>
          {{
            currentSupplier.businessPhoneNumber != ''
              ? currentSupplier.businessPhoneNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Celular') }}:</strong>
          {{
            currentSupplier.businessCellPhoneNumber != ''
              ? currentSupplier.businessCellPhoneNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
    </v-row>
    <v-divider class="my-3 hidden-md-and-up"></v-divider>
    <v-row class="px-5 hidden-md-and-up">
      <v-col cols="12">
        <h3>{{ $t('Endereço') }}</h3>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">CEP:</strong>
          {{
            currentSupplier.cep != ''
              ? currentSupplier.cep
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Logradouro') }}:</strong>
          {{
            currentSupplier.address != ''
              ? currentSupplier.address
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2">
        <p>
          <strong class="field">Número:</strong>
          {{
            currentSupplier.locationNumber != null
              ? currentSupplier.locationNumber
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Complemento') }}:</strong>
          {{
            currentSupplier.complement != ''
              ? currentSupplier.complement
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Bairro') }}:</strong>
          {{
            currentSupplier.district != ''
              ? currentSupplier.district
              : $t('Não informado')
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Cidade') }}:</strong>
          {{ currentSupplier.city }}
        </p>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2">
        <p>
          <strong class="field">UF:</strong>
          {{ currentSupplier.state }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import ManageSupplier from './ManageSupplier.vue'

export default {
  props: {
    receivedSupplier: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.currentSupplier = this.receivedSupplier
  },

  data: () => ({
    currentSupplier: {},
    userType: null,
    dialogKey: false,
    editDialog: false,
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    closeDialog() {
      this.editDialog = false
      this.dialogKey = !this.dialogKey
    },

    editSupplier(supplier) {
      this.currentSupplier = supplier
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },
  },

  components: {
    ManageSupplier,
  },
}
</script>

<style></style>
